module.exports = __webpack_public_path__ + "media/images/lps-income_graph-5ea8f80e.png";